<template>
  <div :class="{resultLoading: 1, article: article}">
    <div class="skAnimation"/>

    <div class="articleLoading" v-if="article">
      <div class="lHeader">
        <div class="lHeaderIn">
          <div class="lTitle"></div>
          <div class="lTitle2"></div>
          <div class="lTitle3"></div>
        </div>
      </div>
      <div class="lContent"/>
    </div>

    <div class="pricingLoading" v-if="pricing">
      <div class="itemCnt">
        <div class="item"/>
        <div class="item recomended"/>
        <div class="item"/>
      </div>
    </div>

    <div class="loadingItemBig" v-if="itemBig">
      <div class="title"/>
      <div class="itemCnt">
        <div class="itemBig"/>
        <div class="itemBig"/>
        <div class="itemBig"/>
        <div class="itemBig"/>
      </div>
    </div>

    <div class="loadingItemXs" v-if="itemXs">
      <div class="title"/>
      <div class="itemCnt">
        <div class="itemXs"/>
        <div class="itemXs"/>
        <div class="itemXs"/>
        <div class="itemXs"/>
        <div class="itemXs"/>
      </div>
    </div>

    <div class="loadingItemSm" v-if="itemSm">
      <div class="title"/>
      <div class="itemCnt">
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
        <div class="itemSm"/>
      </div>
    </div>

    <div class="loadingItem" v-if="itemDetail">
      <div class="loadingImg"/>
      <div class="loadingContent">
        <div class="loadingTitle"/>
        <div class="loadingDesc"/>
        <div class="loadingDesc2"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'skAnimation',
  props: ['itemBig', 'itemSm', 'itemDetail', 'itemXs', 'pricing', 'article'],
};
</script>

<style scoped lang="scss">
  .resultLoading{
    position: relative;
    overflow: hidden;
    padding-top: 30px;
    &.article{
      height: calc(100vh - 64px);
      background-color: #f5f5f5;
      padding-top: 0;
    }
    .skAnimation{
      position: absolute;
      top: -40px;
      bottom: -40px;
      left: -200px;
      width: 200px;
      // background-color: red;
      background-image: linear-gradient(to right, transparent,#fff,transparent);
      z-index: 2;
      animation: skAnimate 2.2s infinite;
      opacity: .8;
      @keyframes skAnimate {
        from { left: -200px; }
        to { left: calc(100% + 200px); }
      }
    }
  }

  .articleLoading{
    background-color: #fff;
    padding-top: 20px;
    .lHeader{
      height: 107px;
      .lHeaderIn{
        max-width: 1180px;
        margin: 0 auto;
        .lTitle{
          height: 18px;
          background-color: #f5f5f5;
          width: 300px;
          max-width: 60%;
        }
        .lTitle2{
          margin: 10px 0;
          height: 29px;
          background-color: #f5f5f5;
          width: 600px;
          max-width: 90%;
        }
        .lTitle3{
          height: 20px;
          background-color: #f5f5f5;
          width: 200px;
          max-width: 50%;
        }
      }
    }
  }

  .pricingLoading{
    padding-bottom: 60px;
    .itemCnt{
      display: flex;
      justify-content: center;
      .item{
        width: 240px;
        height: 300px;
        background-color: #f5f5f5;
        margin: 0 20px;
        border-radius: 10px;
        &.recomended{
          transform: scale(1.1);
        }
      }
    }
  }

  .loadingItemBig{
    overflow: hidden;
    .title{
      height: 20px;
      width: 180px;
      background-color: #f5f5f5;
      margin-bottom: 16px;
      border-radius: 5px;
    }
    .itemCnt{
      display: flex;
      margin-right: -20px;
      @media (max-width: 980px) {
        width: 1280px;
      }
      .itemBig{
        width: calc(25% - 20px);
        height: 440px;
        background-color: #f5f5f5;
        border-radius: 10px;
        margin: 0 20px 20px 0;
        @media (max-width: 1480px) {
          height: 30vw;
        }
        @media (max-width: 980px) {
          width: 300px;
          height: 400px;
        }
      }
    }
  }

  .loadingItemXs{
    .title{
      height: 20px;
      width: 180px;
      background-color: #f5f5f5;
      margin-bottom: 16px;
      border-radius: 5px;
    }
    .itemCnt{
      display: flex;
      .itemXs{
        width: calc(20% - 20px);
        height: 220px;
        background-color: #f5f5f5;
        border-radius: 10px;
        margin: 0 20px 20px 0;
      }
    }
  }

  .loadingItemSm{
    padding-top: 30px;
    .title{
      height: 20px;
      width: 180px;
      background-color: #f5f5f5;
      margin-bottom: 16px;
      border-radius: 5px;
    }
    .itemCnt{
      display: flex;
      flex-wrap: wrap;
      margin-right: -20px;
      .itemSm{
        width: calc(20% - 20px);
        height: 300px;
        background-color: #f5f5f5;
        border-radius: 10px;
        margin: 0 20px 60px 0;
        position: relative;
        @media (max-width: 1480px) {
          height: 20vw;
        }
        @media (max-width: 1160px) {
          width: calc(25% - 20px);
          height: 25vw;
        }
        @media (max-width: 980px) {
          width: calc(33.3333% - 20px);
          height: 33vw;
        }
        @media (max-width: 674px) {
          width: calc(100% - 20px);
          height: 54vw;
          border-radius: 5px;
        }

        &:before{
          content: "";
          display: block;
          background-color: #f5f5f5;
          position: absolute;
          left: 8px; bottom: -20px;
          height: 10px; width: 40%;
          border-radius: 50px;
        }
      }
    }
  }

  .loadingItem{
    margin-bottom: 10px;
    position: relative;
    padding-left: 126px;
    height: 140px;
    .loadingImg{
      position: absolute;
      left: 0; top: -6px;
      width: 100px; height: 100px;
      background-color: #eee;
      border-radius: 5px;
    }
    .loadingContent{
      .loadingTitle{
        width: 80%;
        height: 30px;
        background-color: #eee;
        margin-bottom: 10px;
      }
      .loadingDesc, .loadingDesc2{
        width: 60%;
        height: 16px;
        background-color: #eee;
        margin-bottom: 10px;
      }
      .loadingDesc2{
        width: 40%;
      }
    }
  }
</style>
